import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TcButton from '../TcButton';
import TcPaper from '../TcPaper';
import TcImage from '../TcImage';
import LoadingScreen from '../shared/LoadingScreen';
import { useDeviceDetection } from '../../hooks/useDeviceDetection';
import { useSimpleImagePreloader } from '../../hooks/useImagePreloader';
import TcScanQrCodeBar from '../TcScanQrCodeBar';

import imagePeranakan01 from '../../assets/images/exhibit/peranakan/img_peranakan_01.jpg';
import imagePeranakan02 from '../../assets/images/exhibit/peranakan/img_peranakan_02.jpg';
import imagePeranakan03 from '../../assets/images/exhibit/peranakan/img_peranakan_03.jpg';


export default function PeranakanCulture() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    
    // Device detection
    const { orientation } = useDeviceDetection();
    const isLandscape = orientation === 'landscape';

    // Preload all images when component mounts
    const allImages = [
        imagePeranakan01,
        imagePeranakan02,
        imagePeranakan03
    ];

    const { isLoading, isComplete } = useSimpleImagePreloader(allImages);

    const handleSeePatterns = () => {
        // Navigate to PeranakanPatterns
        navigate('/exhibit/peranakan-patterns');
    };

    const handleReturnToIntro = () => {
        // Navigate to PeranakanDesign
        navigate('/exhibit/peranakan-design');
    };

    // Show loading state while images are being cached
    if (isLoading) {
        return <LoadingScreen message="Loading images..." />;
    }

    // Culture screen
    return (
        <div className={`
            main-content-wrapper bg-black 
            ${isLandscape ? '!pt-8' : '!pt-[112px]'} 
            unselectable 
            has-transition 
        `}>
            <TcPaper classNameStyle="mt-4">
                <h1>{t('exhibits.peranakanDesign.cultureTitle')}</h1>
            </TcPaper>

            <TcImage classNameStyle="mb-4">
                <img
                    src={imagePeranakan01}
                    alt={t('exhibits.peranakanDesign.cultureTitle')}
                    className="w-full"
                />
            </TcImage>

            <TcPaper classNameStyle="general-content">
                <p className="mb-4"
                    dangerouslySetInnerHTML={{ __html: t('exhibits.peranakanDesign.cultureContent1') }}
                />
                <TcImage classNameStyle="mb-4">
                    <img
                        src={imagePeranakan02}
                        alt={t('exhibits.peranakanDesign.cultureContent2')}
                        className="w-full"
                    />
                </TcImage>
                <p className="mb-4"
                    dangerouslySetInnerHTML={{ __html: t('exhibits.peranakanDesign.cultureContent2') }}
                />
                <TcImage classNameStyle="mb-4">
                    <img
                        src={imagePeranakan03}
                        alt={t('exhibits.peranakanDesign.cultureContent3')}
                        className="w-full"
                    />
                </TcImage>
                <p className="mb-4"
                    dangerouslySetInnerHTML={{ __html: t('exhibits.peranakanDesign.cultureContent3') }}
                />
            </TcPaper>

            <div className="button-wrapper flex flex-col gap-4 px-6 pb-6 !max-w-lg has-transition">
                <TcButton
                    handleClick={handleSeePatterns}
                    primary
                >
                    {t('exhibits.peranakanDesign.returnToInteractiveTiles')}
                </TcButton>
                <TcButton
                    handleClick={handleReturnToIntro}
                    primary
                >
                    {t('exhibits.peranakanDesign.returnToIntro')}
                </TcButton>
            </div>

            <TcScanQrCodeBar classNameStyle="fixed bottom-0 left-0 right-0 z-[20]" />
        </div>
    );
} 